import { render } from "./PersonCenter.vue?vue&type=template&id=3748df7c&scoped=true&ts=true"
import script from "./personCenterHelper.ts?vue&type=script&lang=ts"
export * from "./personCenterHelper.ts?vue&type=script&lang=ts"

import "./PersonCenter.vue?vue&type=style&index=0&id=3748df7c&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3748df7c"]])

export default __exports__